// Cache Tags
export const TAG_INDUSTRIES = 'INDUSTRIES'
export default [TAG_INDUSTRIES]

// Endpoints
export const GET_INDUSTRIES = 'getIndustries'
